export const steps = [
  `Click on "Pay" and proceed towards the payment gateway for completion of transaction process.`,
  `Upon successful transaction verification, Fill up the registration form. In case of any discrepancies in the process, you will be prompted to verify again.`,
  `After registration, don't forget to join us on 2nd April 2022.`,
];
